import type { CrmLiveNow } from '@chatbot/shared-types';
import { Card, CardBody, CardHeader } from '../ui/index.ts';

/**
 * Estado actual de las conversaciones (snapshot en vivo).
 * Colores semánticos de estado: nunca se reutilizan para series de datos.
 */
const STATES: Array<{ key: keyof CrmLiveNow; label: string; dot: string; value: string }> = [
  {
    key: 'bot_active',
    label: 'Atendidas por el bot',
    dot: 'bg-primary-500',
    value: 'text-primary-700 dark:text-primary-300',
  },
  {
    key: 'pending_human',
    label: 'Esperando agente',
    dot: 'bg-warning-500',
    value: 'text-warning-700 dark:text-warning-300',
  },
  {
    key: 'human_active',
    label: 'Con agente humano',
    dot: 'bg-info-500',
    value: 'text-info-700 dark:text-info-500',
  },
  {
    key: 'resolved',
    label: 'Resueltas',
    dot: 'bg-success-500',
    value: 'text-success-700 dark:text-success-500',
  },
];

export function LiveNowPanel({ liveNow }: { liveNow: CrmLiveNow }) {
  return (
    <Card variant="default" data-testid="metrics-live-now">
      <CardHeader>
        <h3 className="text-h5 text-neutral-900 dark:text-neutral-100">Estado actual</h3>
        <p className="text-caption text-neutral-500 dark:text-neutral-400">
          Conversaciones en este momento
        </p>
      </CardHeader>
      <CardBody className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {STATES.map((s) => (
          <div
            key={s.key}
            className="flex flex-col gap-1 rounded-lg border border-neutral-200 dark:border-neutral-700 px-4 py-3"
          >
            <span className="flex items-center gap-2 text-xs font-mono uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
              <span className={`h-2 w-2 rounded-full ${s.dot}`} aria-hidden="true" />
              {s.label}
            </span>
            <span className={`text-2xl font-bold tabular-nums ${s.value}`}>
              {liveNow[s.key].toLocaleString('es-CO')}
            </span>
          </div>
        ))}
      </CardBody>
    </Card>
  );
}
